document.addEventListener('DOMContentLoaded', function () {
    var input  = document.getElementById('donation-amount');
    var hidden = document.getElementById('p24_amount');
    if (!input || !hidden) return;

    input.addEventListener('input', function () {
        var val = parseInt(input.value, 10);
        hidden.value = (val > 0 ? val : 1) * 100;
    });
});
